import React, {useState} from 'react';
import styles from './DialogSentence.module.css';

function DialogSentence({ character, sentenceFragments, className}) {

    return (
        <div className={`${styles.container} ${className ? className : ''}`} >

            {character && character !== '' && character !== '#' &&
                <div className={styles.character}>{character}:</div>
            }
    
            <div className={styles.sentence}>
                {
                    sentenceFragments.map((fragment, index) => {
                        return (
                            <span key={index} className={`${styles.fragment} ${fragment.highlight ? styles.highlight : ''}`}>
                                {fragment.text}
                            </span>
                        );
                    })
                }
            </div>
        </div>
    );
}

export default DialogSentence;